import { useRole } from '../../hooks/useRole';
import UserRoleManager from './UserRoleManager';
import PendingUserManager from './PendingUserManager';

export default function AdminDashboard() {
  const { isSuperAdmin, hasAdminAccess } = useRole();

  // ✅ Restrict access if not admin
  if (!hasAdminAccess) {
    return (
      <div className="max-w-4xl mx-auto p-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <h2 className="text-xl font-semibold text-red-800 mb-2">Access Denied</h2>
          <p className="text-red-700">You don't have permission to access the admin dashboard.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Admin Dashboard</h1>
        <p className="text-gray-600">Manage pending user approvals and role assignments</p>
      </div>

      <div className="space-y-8">
        {/* ✅ Pending User Approvals */}
        {isSuperAdmin && <PendingUserManager />}

        {/* ✅ User Role Management */}
        {isSuperAdmin && <UserRoleManager />}
      </div>
    </div>
  );
}


